import React from 'react';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import { FormContext, FormUtils } from '../../../molecules/Form';
import { Namespace } from '../../../../translation/namespace';
import Form from '../../../molecules/Form/Form';
import FormInput from '../../../molecules/Form/components/FormInput/FormInput';
import FormsRow from '../../../molecules/Form/components/FormsRow/FormsRow';
import LiveRegion from '../../../atoms/LiveRegion/LiveRegion';
import { FormSubmitButton } from '../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';

// we need a special validate function here as we need to regex every input
// one pattern for all this was deemed to troublesome as we encountered a regexbomb
function validate(allowedCSPSources: string | undefined, value: string, t: TFunction<string>) {
  const valuesToCheck: string[] = value?.split(',').map((v: string) => v.trim());

  if (allowedCSPSources && valuesToCheck?.some(v => !v.match(allowedCSPSources))) {
    return t(`edit.invalidFormat`);
  }
  return '';
}

type CspEditFormProps = {
  form: any;
  refresh: () => void;
};

export default function CspEditForm({ form, refresh }: CspEditFormProps) {
  const { t } = useTranslation(Namespace.CspFrameSourceConfig);

  const statusMessages = () => {
    return {
      [InteractionStatus.SENDING]: FormUtils.createStatusMessage(
        t(`${Namespace.phrases}:processIsCurrentlyRunningWithDots`),
      ),
      [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t(`${Namespace.phrases}:changeSuccesfull`)),
      [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t(`${Namespace.phrases}:changesCouldNotBeSaved`)),
    };
  };

  const refreshBlock = () => {
    setTimeout(() => refresh(), 2000);
  };

  return (
    <Form id="csp-edit-form" model={form} onSuccess={() => refreshBlock()}>
      <FormContext.Consumer>
        {({ onChange, getStatus, submitActionEnabled, inputs }) => {
          const cspInput = inputs.son_portal_security_csp_frameSrc;

          return (
            <>
              <FormsRow>
                <FormInput
                  id={cspInput.name}
                  value={cspInput.value}
                  type={cspInput.type}
                  name={cspInput.name}
                  required={cspInput.required}
                  labelTitle={t('edit.labelTitle')}
                  pattern={cspInput.constraints?.pattern}
                  maxLength={cspInput.constraints?.maxLength}
                  onChange={(event: { target: { name: string; value: any } }) =>
                    onChange(event.target.name, event.target.value)}
                  labelHelpText={t('edit.labelHelpText')}
                  validationMessage={validate(cspInput.constraints?.pattern, cspInput.value, t)}
                />
              </FormsRow>
              <FormSubmitButton buttonLabel={t(`edit.button`)} enabled={submitActionEnabled()} />
              <LiveRegion htmlTag="div" invisible={false} ariaAtomic>
                {getStatus(statusMessages())}
              </LiveRegion>
            </>
          );
        }}
      </FormContext.Consumer>
    </Form>
  );
}
